<div class="workflow-kanban-container">
    <div class="process-list-area" kendoTooltip tooltipClass="tooltip-adjust-right"
        *ngIf="selectedProcessDef && !isShowAsTab">
        <div class="top-left">
            <div class="project-name text-ellipsis" [title]="selectedProcessDef.name">
                {{selectedProcessDef.name}}
            </div>
            <button tam-button tamType="primary" tamSize="normal" [disabled]="disableStartNewProject"
                (click)="startNewProcess($event)">
                New Project
            </button>
        </div>
        <smart-icon name="meatball" class='light' (click)="onOperationShowContextMenu($event)"
            *ngIf="!isIPAD && (isAdminUser && isPPCUser)">
        </smart-icon>
    </div>
    <tam-context-menu [config]="operationContextMenuConfig"></tam-context-menu>
    <div class="tabs">
        <tam-tab-set tid="workflow_screen_tabs" [selectedIndex]="selectedIndex"
            (selectChange)="onTabSelectChange($event)">
            <tam-tab title="Task Board"></tam-tab>
            <tam-tab title="Project Board"></tam-tab>
        </tam-tab-set>
    </div>
    <div class="contents" [style.height]="contentsHeight" *ngIf="selectedProcessDef">
        <tam-task-view [hidden]="!isTaskKanbanActive" [processDefinition]="selectedProcessDefVm"
            [active]="isTaskKanbanActive">
        </tam-task-view>
        <tam-instance-view [hidden]="!isInstanceKanbanActive" [processDefinition]="selectedProcessDefVm"
            [active]="isInstanceKanbanActive" [isInited]="isInstanceKanbanClicked">
        </tam-instance-view>
    </div>
</div>